export const MANUFACTURER_REPORT_NAMES = [
  "Med PA Report",
  "SP Transfers Report",
  "Full Report",
  "Case Mgmt Report",
  "Call Report",
  "Denial Report",
]

export const CASE_DETAIL_HEADER = [
  {
    value: 'case_id',
    label: 'Case ID',
  },
  {
    value: 'patient_id',
    label: 'Patient ID',
  },
  {
    value: 'bi_ct',
    label: 'BI #',
  },
  {
    value: 'qty',
    label: 'Qty',
  },
  {
    value: 'received',
    label: 'Received',
  },
  {
    value: 'completed',
    label: 'Completed',
  },
  {
    value: 'treatment',
    label: 'Treatment',
  },
  {
    value: 'payer',
    label: 'Payer',
  },
  {
    value: '',
    label: 'Outcome',
  },
  {
    value: '',
    label: 'Rx Cvge',
  },
  {
    value: '',
    label: 'Med Cvge',
  },
  {
    value: '',
    label: 'Rx PA',
  },
  {
    value: '',
    label: 'Med PA',
  },
  {
    value: '',
    label: 'Case Status',
    width: 250
  },
  {
    value: '',
    label: 'Update',
  },
  {
    value: 'doc_name',
    label: 'Provider',
  },
];

export const ONGOING_TREATMENTS_HEADER = [
  {
    value: 'case_id',
    label: 'Case ID',
  },
  {
    value: 'patient_id',
    label: 'Patient ID',
  },
  {
    value: 'Bi',
    label: 'BI #',
  },
  {
    value: 'qty',
    label: 'Qty',
  },
 
  {
    value: 'Prevous_treatment_date',
    label: 'Previous Treatment Date',
  },
  {
    value: 'insurance_name',
    label: 'Payer',
  },
  {
    value: '',
    label: 'Outcome',
  },
  {
    value: '',
    label: 'Rx Cvge',
  },
  {
    value: '',
    label: 'Med Cvge',
  },
  {
    value: '',
    label: 'Rx PA',
  },
  {
    value: '',
    label: 'Med PA',
  },
  {
    value: '',
    label: 'Case Status',
    width: 250
  },
  {
    value: '',
    label: 'Type',
  },
  {
    value: 'doc_name',
    label: 'Provider',
  },
];


export const PROVIDER_HEADER = [
  {
    value: '',
    label: 'Providers',
  },
  {
    value: '',
    label: 'Commercial',
  },
  {
    value: '',
    label: 'Medicare',
  },
  {
    value: '',
    label: 'Medicare advantage',
  },
 
  {
    value: '',
    label: 'Unspecified',
  },
  {
    value: '',
    label: 'Total Cases',
  },
  
];

export const CASE_NOTE_DROPDOWN = [
  "Scheduled",
  "Need to Schedule",
  "Need to Re-run",
  "Pending Specialty Pharmacy",
  "Pending Prior Authorization Approval",
  "Requires Office Attention",
  "Office Authorization Required",
  "Copay Card Needed",
  "Third Party Block",
  "Patient Needs to Call Pharmacy",
  "Unable to Reach Patient",
  "Office Need to Call Pharmacy",
  "Offices Needs to Verify Fee Schedule",
  "Office Needs to Update Insurance",
  "Pending P&amp;T Approval",
  "Pre-Certification Required",
];
